export default class YoutubeVideo {
    constructor(obj) {
        this.id = obj.id;
        this.title = obj.Titolo;
        this.youtubeId = obj.YouTubeId;
        this.url = obj.Url;
    }
}